import { render } from "./polyDataShow.vue?vue&type=template&id=65f6c0f2"
import script from "./polyDataShow.vue?vue&type=script&lang=js"
export * from "./polyDataShow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__